"use strict";
import * as wishlistbundle from "@elements/wishlist";
import {findAllIn, find, findIn, addClass, removeClass, findAll, on} from "@elements/dom-utils";
import {onFind } from "@elements/init-modules-in-scope";

let wishlist = null;
if (window['_wishlist']) {
    wishlist = wishlistbundle.createWishlist({
        ...window['_wishlist'],
        notificationOptions: {
            $container: find('.js-wishlist__notification'),
        }
    })
}

let myWishlists = [];
if (window['_wishlists']) {
    for(let i = 0; i < window['_wishlists'].length; i++){
        myWishlists.push(wishlistbundle.createWishlist({
            ...window['_wishlists'][i],
            notificationOptions: {
                $container: find('.js-wishlist__notification'),
            }
        }, {
            item: '.js-wishlist-' + i + '__btn',
            itemId: 'wishlist-id',
            wishlistId: 'wishlist-list',
            itemActiveClass: 'is-active'
        }));
    }
}

export function init() {
    if (myWishlists.length) {
        myWishlists.forEach((wishlist) => {
            wishlist.init();
        });
    }
    if(wishlist){
        wishlist.init();
    }

}

export function initInScope(scope = find('body') ) {
    if (myWishlists.length) {
        myWishlists.forEach((wishlist) => {
            wishlist.initInScope(scope);

            let wishListContainer = findAllIn('.js-wishlist__container',scope);

            wishListContainer.forEach((el) => {
                const container    = el,
                    button     = findIn('.js-wishlist__remove',container),
                    id          = container.getAttribute('data-wishlist-id');

                const buttonClickHandler = (evt, button) => {
                    evt.preventDefault();
                    let _request = wishlist.remove(id, {showUndo: true});
                    _request.then(result => result.json()).then(function(res) {
                        if(res.success){
                            container.remove();
                        }
                    })
                };

                on('click', (evt) => buttonClickHandler(evt, button), button);

            });
        });

    }

    const addedWishlistHandler = (evt, params) => {


        onFind('.js-wishlist__sum', function(baseElement){
            addClass('wishlist-animation', baseElement);
            setTimeout(function(){
                removeClass('wishlist-animation', baseElement);
            }, 1000);
        });



    };


    on('added.wishlist', (evt) => addedWishlistHandler('params', evt.detail) , document);


    if(wishlist){
        wishlist.initInScope(scope);
    }
}